import { AuthGuard } from './auth/auth.guard';
import { IconReadyGuard } from './icons/icons.guard';

export const guards = [AuthGuard, IconReadyGuard];

export * from './auth/auth.guard';
export * from './icons/icons.guard';
